import localizationStrings from "./localization";

const copy = {
  eng: {
    selection: "THE ATLAS SELECTION",
    discover: "A world worth watching.",
    intro: "Great stories. Unexpected discoveries. All in one place.",
    forYou: "Picked for you",
    personal: "YOUR NEXT GREAT STORY",
    collection: "Explore the collection",
    live: "Live TV",
    onAir: "HAPPENING NOW",
    liveTitle: "Be part of the moment.",
    liveDescription:
      "Your favourite channels, all together. Tune in to what's on now.",
    liveAction: "Explore live TV",
    previous: "Previous",
    next: "Next",
    pause: "Pause slideshow",
    resume: "Play slideshow",
    search: "Search",
    clearSearch: "Clear search",
    suggestions: "Search suggestions",
    popularSearches: "Popular searches",
    recent: "Recent",
    noItems: "Nothing here yet. Discover something new with a search.",
    loadError: "We couldn't load this right now. Please try again.",
    retry: "Try again",
    all: "View all",
    more: "Explore",
    watch: "Watch now",
    preview: "Preview",
    info: "More info",
    movie: "Movie",
    series: "Series",
    program: "On TV",
    contentInfo: "Content information",
    allAges: "All ages",
    continue: "Continue watching",
    collectionNote: "A little inspiration for your next watch.",
    featured: "FEATURED",
    guide: "TV guide",
    cinema: "EVERY STORY. A NEW WORLD.",
    login: "Your next great story starts here.",
    loginNote: "Movies, series and the moments you don't want to miss.",
    companion: "Atlas Compass",
    footer: "Every story opens a new world.",
    profile: "Profile menu",
    loading: "Finding your next great story…"
  },
  tr: {
    selection: "ATLAS SEÇKİSİ",
    discover: "İzlemeye değer bir dünya.",
    intro: "Büyük hikâyeler. Beklenmedik keşifler. Hepsi bir arada.",
    forYou: "Senin için seçtik",
    personal: "SIRADAKİ HİKÂYEN",
    collection: "Koleksiyonu keşfet",
    live: "Canlı TV",
    onAir: "ŞİMDİ YAYINDA",
    liveTitle: "Anın bir parçası ol.",
    liveDescription:
      "Sevdiğin kanallar bir arada. Şimdi yayında olanları keşfet.",
    liveAction: "Canlı TV’yi keşfet",
    previous: "Önceki",
    next: "Sonraki",
    pause: "Slaytları duraklat",
    resume: "Slaytları oynat",
    search: "Ara",
    clearSearch: "Aramayı temizle",
    suggestions: "Arama önerileri",
    popularSearches: "Popüler aramalar",
    recent: "Son aramalar",
    noItems: "Henüz içerik yok. Arama yaparak yeni bir şey keşfet.",
    loadError: "Şu anda yükleyemedik. Tekrar deneyebilirsin.",
    retry: "Tekrar dene",
    all: "Tümünü gör",
    more: "Keşfet",
    watch: "Hemen izle",
    preview: "Ön izleme",
    info: "Detayları gör",
    movie: "Film",
    series: "Dizi",
    program: "TV’de",
    contentInfo: "İçerik bilgileri",
    allAges: "Genel izleyici",
    continue: "İzlemeye devam et",
    collectionNote: "Sıradaki hikâyen için biraz ilham.",
    featured: "ÖNE ÇIKAN",
    guide: "Yayın akışı",
    cinema: "HER HİKÂYE. YENİ BİR DÜNYA.",
    login: "Sıradaki büyük hikâyen burada başlıyor.",
    loginNote: "Filmler, diziler ve kaçırmak istemeyeceğin anlar.",
    companion: "Atlas Compass",
    footer: "Her hikâye yeni bir dünyaya açılır.",
    profile: "Profil menüsü",
    loading: "Sıradaki hikâyen hazırlanıyor…"
  },
  arb: {
    selection: "مختارات أطلس",
    discover: "عالم يستحق المشاهدة.",
    intro: "قصص رائعة واكتشافات جديدة. كلها في مكان واحد.",
    forYou: "اخترنا لك",
    personal: "قصتك الرائعة التالية",
    collection: "اكتشف المجموعة",
    live: "البث المباشر",
    onAir: "مباشر الآن",
    liveTitle: "كن جزءاً من اللحظة.",
    liveDescription: "قنواتك المفضلة معاً. اكتشف ما يُعرض الآن.",
    liveAction: "اكتشف البث المباشر",
    previous: "السابق",
    next: "التالي",
    pause: "إيقاف العرض",
    resume: "تشغيل العرض",
    search: "بحث",
    clearSearch: "مسح البحث",
    suggestions: "اقتراحات البحث",
    popularSearches: "عمليات البحث الشائعة",
    recent: "الأخيرة",
    noItems: "لا يوجد محتوى بعد. اكتشف شيئاً جديداً بالبحث.",
    loadError: "تعذر التحميل الآن. يرجى المحاولة مرة أخرى.",
    retry: "إعادة المحاولة",
    all: "عرض الكل",
    more: "اكتشف",
    watch: "شاهد الآن",
    preview: "معاينة",
    info: "التفاصيل",
    movie: "فيلم",
    series: "مسلسل",
    program: "على التلفزيون",
    contentInfo: "معلومات المحتوى",
    allAges: "لجميع الأعمار",
    continue: "تابع المشاهدة",
    collectionNote: "إلهام لمشاهدتك التالية.",
    featured: "مميز",
    guide: "دليل التلفزيون",
    cinema: "كل قصة. عالم جديد.",
    login: "قصتك الرائعة التالية تبدأ هنا.",
    loginNote: "أفلام ومسلسلات ولحظات لا تريد تفويتها.",
    companion: "Atlas Compass",
    footer: "كل قصة تفتح عالماً جديداً.",
    profile: "قائمة الملف الشخصي",
    loading: "نحضّر قصتك التالية…"
  }
};

export const getCinemaCopy = () =>
  copy[localizationStrings.getLanguage()] || copy.eng;
